import React, { Component } from "react";
import PropTypes from "prop-types";
import throttle from "lodash.throttle";
import usFlag from "../../../img/AmericaFlag.webp";
import krFlag from "../../../img/KoreaFlag.webp";
import { Icon, Popover } from "antd";

// use babel-import-plugin as specified in Ant Design Docs!
// https://ant.design/docs/react/getting-started#Import-on-Demand
// import Popover from "antd/lib/popover";
// import Icon from "antd/lib/icon";
// import "antd/lib/popover/style/css";
// import "antd/lib/icon/style/css";

import "./styles.css";

class ResponsiveNav extends Component {
  state = {
    viewportWidth: 0,
    menuVisible: false,
  };

  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  handleMenuVisibility = (menuVisible) => {
    this.setState({ menuVisible });
  };

  saveViewportDimensions = throttle(() => {
    this.setState({
      viewportWidth: window.innerWidth,
    });
  }, this.props.applyViewportChange);

  render() {
    const MenuMarkup = this.props.menuMarkup;

    if (this.state.viewportWidth > this.props.mobileBreakPoint) {
      return <MenuMarkup activeLinkKey={this.props.activeLinkKey} />;
    }

    return (
      <Popover
        content={
          <MenuMarkup
            onLinkClick={() => this.handleMenuVisibility(false)}
            activeLinkKey={this.props.activeLinkKey}
            mobileVersion
            // className='to-override-mobile-menu-class'
          />
        }
        trigger="click"
        placement={this.props.placement}
        visible={this.state.menuVisible}
        onVisibleChange={this.handleMenuVisibility}
      >
        <Icon
          type="menu"
          style={{
            display: "block",
            position: "absolute",
            right: "15px",
            fontSize: "23px",
            top: "18px",
          }}
        />
      </Popover>
    );
  }
}

ResponsiveNav.propTypes = {
  mobileBreakPoint: PropTypes.number,
  applyViewportChange: PropTypes.number,
  activeLinkKey: PropTypes.string,
  placement: PropTypes.string,
  menuMarkup: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

ResponsiveNav.defaultProps = {
  mobileBreakPoint: 575,
  applyViewportChange: 250,
  placement: "bottom",
};

export default ResponsiveNav;



// WEBPACK FOOTER //
// ./src/components-kr/menu/ResponsiveNav/ResponsiveNav.js